<template>
  <div class="container">
    <div class="content">
      <div class="left_content">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img src="@/assets/banner/01.jpg" alt />
            </div>
            <div class="swiper-slide">
              <img src="@/assets/banner/02.jpg" alt />
            </div>
            <div class="swiper-slide">
              <img src="@/assets/banner/03.jpg" alt />
            </div>
          </div>
          <!-- 如果需要分页器 -->
          <div class="swiper-pagination"></div>
        </div>
      </div>
      <div class="right_content">
        <div class="login_box">
          <!-- 登录表单区域 -->
          <div slot="header" class="title">
            <span>Welcome to Rifeng Guard</span>
          </div>
          <el-form
            ref="loginFormRef"
            :model="loginForm"
            :rules="loginFormRules"
            label-width="0"
            class="login_form"
          >
            <!-- 用户名 -->
            <el-form-item prop="username">
              <el-input
                v-model="loginForm.username"
                prefix-icon="iconfont icon-icon_user"
                placeholder="Account"
              ></el-input>
            </el-form-item>
            <!-- 密码 -->
            <el-form-item prop="password">
              <passinput v-model="loginForm.password"></passinput>
            </el-form-item>

            <!-- 验证码 -->
            <el-form-item prop="captcha" class="vcode">
              <el-input
                v-model="loginForm.captcha"
                prefix-icon="iconfont icon-yanzhengma"
                type="captcha"
                placeholder="Verification code"
                @keyup.enter.native="login"
              ></el-input>
              <img :src="imgSrc" @click="changeVcode" />
            </el-form-item>

            <el-form-item class="forgetpass">
              <el-link type="primary" @click="retrievePass">Forget Password</el-link>
            </el-form-item>

            <!-- 按钮区域 -->
            <el-form-item class="btns">
              <el-button type="primary" class="login" @click="login">Login</el-button>
              <el-button @click="toRegister" class="signup">Sign Up</el-button>
            </el-form-item>

            <div class="app-download">
              <el-link type="primary" @click="appDownloadVisible = true">App Download</el-link>
            </div>
          </el-form>
        </div>
      </div>
      <el-dialog  :visible.sync="appDownloadVisible" width="40%"  slot="title">
        <template slot="title">
          <div class="down-title">App Download</div>
        </template>
        <div class ="down-content">
            <div class="store" @click="openWinIos" ><img src="@/assets/img/store/app-store.png" width="64px" height="64px" /><div class="app"><span>IOS</span> <span class="span2">App Store</span></div></div>
            <div class="store" @click="openWinAndroid"><img src="@/assets/img/store/google_play.png" width="64px" height="64px" /><div class="app"><span>Android</span> <span class="span2">Google Play</span></div></div>
        </div>
        <!-- <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">Cancel</el-button>
        </span> -->
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'
import passinput from '@/components/passInput/PassInput'

import db from '@/services/localstorage'
import md5 from 'md5'

export default {
  components: {
    passinput,
  },
  data() {
    return {
      // 登录协议
      loginAgreement: '',
      // 这是登录表单的数据绑定对象
      loginForm: {
        username: '',
        password: '',
        // 验证码
        captcha: '',
        captcheKey: '',
      },
      // 这是表单的验证规则对象
      loginFormRules: {
        // 验证用户名是否合法
        username: [
          {
            required: true,
            message: 'Please enter the account',
            trigger: 'blur',
          },
          {
            min: 3,
            max: 100,
            message: 'Length between 3 and 100 characters',
            trigger: 'blur',
          },
        ],
        // 验证密码是否合法
        password: [
          {
            required: true,
            message: 'Please enter the password',
            trigger: 'blur',
          },
        ],
        captcha: [
          {
            required: true,
            message: 'Please enter the verification code',
            trigger: 'blur',
          },
        ],
      },
      imgSrc: '',
      // 用户验证参数
      key: '',

      appDownloadVisible: false,
    }
  },
  methods: {
    openWinIos(){
        var tempwindow=window.open('_blank');
       tempwindow.location='https://apps.apple.com/cn/app/rifeng-guard/id1533395964';
    },
    openWinAndroid(){
        var tempwindow=window.open('_blank');
       tempwindow.location='https://play.google.com/store/apps/details?id=com.eb.rifeng.safeeu';
    },
    // 打开下载按钮弹窗
    openDownload() {},
    // 找回密码
    retrievePass() {
      this.$router.push({
        path: '/retrieve',
      })
    },
    // 点解切换注册页面
    toRegister() {
      this.$router.push({
        path: '/register',
      })
    },
    login() {
      this.$refs.loginFormRef.validate(async (valid) => {
        if (!valid) return
        let tempUsername = this.loginForm.username
        let tempPass = this.loginForm.password
        console.log(tempPass)
        this.loginForm.password = md5(this.loginForm.password)

        let params = JSON.stringify(this.loginForm)

        // 后台登录接口
        this.$post('auth/login', params).then(({ data: res }) => {
          if (!res.ok) {
            this.$message.error(res.msg)
            if (res.code == 500) {
              console.log(this)
              // 如果账号密码错误，清空密码验证码
              this.loginForm.password = '' //清空密码
            } else if (res.code == 600) {
              // 验证码错误刷新验证码，不清空密码
              this.loginForm.password = tempPass
            } else {
              // 账号已停用
              this.loginForm.username = ''
              this.loginForm.password = ''
            }
            this.loginForm.captcha = ''
            this.getVcode()
          }
          db.save('userId', res.data.user.userId)
          db.save('token', res.data.token)
          db.save('user', res.data.user)
          if (res.data.loginCount == 0) {
            // 登陆前获取协议
            this.$get('agreement/getAgreementByType/login').then(
              ({ data: res2 }) => {
                this.$confirm(res2.data.context, 'Login agreement', {
                  dangerouslyUseHTMLString: true,
                  distinguishCancelAndClose: true,
                  confirmButtonText: 'Yes',
                  cancelButtonText: 'No',
                  customClass: 'messageBox',
                })
                  .then(() => {
                    this.$get('auth/agreeAggrement').then(({ data: resp }) => {
                      if (!resp.ok) {
                      }
                      this.$message.success(res.msg)
                      //按照角色设置默认的首页
                      if (
                        res.data.user.indexUrl != '' &&
                        res.data.user.indexUrl != null
                      ) {
                        this.$router.push(res.data.user.indexUrl)
                      } else {
                        this.$router.push('/welcome4')
                      }
                    })
                  })
                  .catch(() => {
                    // 不清空账号密码
                    this.loginForm.username = tempUsername
                    this.loginForm.password = tempPass
                    // 清空验证码
                    this.loginForm.captcha = ''
                    this.getVcode()
                  })
              }
            )
          } else {
            if (
              res.data.user.indexUrl != '' &&
              res.data.user.indexUrl != null
            ) {
              this.$router.push(res.data.user.indexUrl)
            } else {
              this.$router.push('/welcome4')
            }
          }
        })
      })
    },
    // 点击切换验证码
    changeVcode() {
      this.getVcode()
    },

    async getVcode() {
      let params = {
        oldKey: this.loginForm.captcheKey,
      }

      // 获取登录的验证码 进行用户判断
      this.$get('auth/getCaptchaBase64', { params }).then(({ data: res1 }) => {
        this.imgSrc = 'data:image/jpeg;base64,' + res1.base64String
        this.loginForm.captcheKey = res1.key
      })
    },
  },
  created() {
    this.getVcode()
  },

  mounted() {
    var mySwiper = new Swiper('.swiper-container', {
      direction: 'vertical', // 垂直切换选项
      loop: true, // 循环模式选项
      autoplay: {
        // 自动播放
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
        autoplayDisableOnInteraction: false,
      },
      // 如果需要分页器
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    })
  },
}
</script>

<style lang="less" scoped>
.container {
  height: 100vh;
  min-width: 7.0833rem;
  display: flex;
  align-items: center;
  background: url(../assets/img/background.jpg) no-repeat;
  background-size: 100% 100%;
  .content {
    height: 3.9063rem;
    width: 75vw;
    display: flex;
    margin: 0 auto;
    overflow: hidden;
    .left_content {
      height: 100%;
      // width: 1200px;
      flex: 1;
      background: #ccc;

      .swiper-container {
        height: 100%;
        .swiper-slide {
          height: 100%;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .right_content {
      width: 2.0833rem;
      display: flex;
      align-items: center;
      height: 100%;
      background: #fff;
      .login_box {
        width: 30vw;
        max-width: 2.0833rem;
        min-width: 1.4375rem;
        height: 350px;
        flex: 1;
        background-color: #fff;
        border-radius: 3px;

        .title {
          text-align: center;
          font-weight: bold;
          color: #3c5179;
          margin-bottom: 50px;
          font-size: 20px;
        }

        .login_form {
          width: 100%;
          padding: 0 20px;
          box-sizing: border-box;

          .forgetpass {
            display: flex;
            justify-content: flex-end;
          }

          .app-download {
            margin-top: 0.5208rem;
            display: flex;
            justify-content: flex-end;
            .el-link {
              border-bottom: 1px solid;
            }
          }
        }
      }
    }
  }
}

/deep/.swiper-pagination-bullet {
  background: #fff !important;
}

.vcode {
  display: flex;
  justify-content: space-around;
  img {
    height: 0.2083rem;
    width: 0.5208rem;
    margin-left: 5px;
    border-radius: 2px;
    border: 1px solid #e2e4ea;
    box-sizing: border-box;
  }
  /deep/.el-form-item__content {
    flex: 1;
    display: flex;
    justify-content: space-between;
  }
}

.btns {
  display: flex;
  .el-button {
    font-size: 0.0885rem;
    font-weight: bold;
  }
  .login {
    background: #3c5179;
    border: none;
  }
  .signup {
    margin-left: 0.1302rem;
    border: none;
  }
}

/deep/.el-input__prefix {
  color: #8994b0;
}

.down-title{
  padding-left:30px;
  padding-top: 10px;
  font-weight: bold;
  font-size: 26px;
  color: dimgrey;
}

.down-content{
  width:100%;
  height:180px;
  display: flex;
  direction: row;
  margin:0;
  padding:0;
  align-items:center;/*垂直居中*/
  justify-content: space-around;/*水平居中*/
  .store{
    cursor: pointer;
    display: flex;
    direction: row;
    justify-content: space-around;
    align-items:center;/*垂直居中*/
    background: dimgrey;
    height: 100px;
    width: 250px;
    color: #fff;
    font-size: 24px;
    font-weight: bold;
    border-radius: 10px;
    .app{
      display: flex;
      flex-direction: column;
      align-items: center ;
      justify-items: center;
      padding-right: 20px;

      .span2{
        padding-top: 10px;
        font-size: 20px;
      }
    }
  }
}
// ----------------------------------------------------------------------------
</style>
